export const en = {
  posts: 'posts',
  instagram_table: 'instagram table',
  linkedin_table: 'linkedin table',
  searchBy_caption: 'search by posts caption',
  searchBy_post_code: 'search by post code',
  post_type: 'post type',
  post_code: 'post code',
  comments: 'comments',
  media_count: 'media count',
  media_type: 'media type',
  posted_at: 'posted at',
  instagram_posts: 'instagram posts',
  linkedin_posts: 'linkedin posts',
  incomplete: 'incomplete',
  analyze: 'analyze',
  hashtags: 'hashtags',
  tagged_user: 'tagged users',
  mentioned_user: 'mentioned users',
  post_date: 'post date',
  post_likes: 'post likes',
  post_comments: 'post comments',
  post_shares: 'post shares',
  post_saves: 'post saves',
  post_sponsored: 'post sponsored',
  post_pinned: 'post pinned',
  post_plays: 'post plays',
  post_views: 'post views',
  post_location: 'post location',
  selectGrab: 'select what to regrab for selected post/s before download',
  post_media: 'post media',
  most_mentioned_users: 'most_mentioned_users',
  frequently_used_hashtags: 'frequently used hashtags',
  influencer_details: 'influencer/entity details',
  sponsored: 'sponsored',
  pin: 'pin',
  comments_sentiment: 'comments sentiment',
  most_frequent_word: 'most frequent word',
  frequently_used_words: 'frequently used words',
  tagged_users: 'tagged users',
  post_media_classification: 'post media classification',
  co_author_producer: 'co-author producer',
  disabled: 'Disabled',
  post_details: 'post details',
  add_new_post: 'add new post',
  type_post: 'type post url/code',
  tiktok_type_post: 'type post url/ID',
  invalid_Post: 'Invalid Post Code/URL',
  min_Post: 'This field is required and minimum length is 2 chars',
  max_Post: 'This field is required and maximum length is 150 chars',
  post: 'post',
  duplicate_post: ' This post already exists in the system',
  post_exists_incomplete:
    'This post exists in the system before ,  click here to show details  ',
  regrab_reply_conversation: 'Regrab reply conversation',
  reply_conversation: 'reply conversation',
  replies: 'replies',
  search_by_comment_reply: 'search by comment/reply content',
  comment: 'comment',
  reply: 'reply',
  most_mentioned_users: 'most mentioned users',
  posts_sentiment_analysis: 'posts sentiment analysis',
  view_replies: 'view replies',
  hide_replies: 'hide replies',
  edited: 'edited',
  enabled: 'enabled',
  number_of_instagram_posts: 'number of instagram posts',
  number_of_tiktok_posts: 'number of tiktok posts',
  number_of_linkedin_posts: 'number of linkedin posts',
  comments_status: 'comments status',
  tiktok_posts: 'tiktok posts',
  posts_breakdown:'posts breakdown',
  tiktok_table: 'tiktok table',
  searchBy_post_id: 'search By post id',
  total_reactions: 'total reactions',
  post_total_reactions: 'post total reactions',
  post_reposts: 'post reposts',
  reposts: 'reposts',
  posted_on: 'posted on',
  favorites: 'favorites',
  post_id: 'post id',
  advertisement: 'advertisement',
  post_hashtags: 'post hashtags',
  downloads: 'downloads',
  total_posts:'total posts',
  likes: 'likes',
  comments: 'comments',
  plays: 'plays',
  shares: 'shares',
  saves: 'saves',
  location: 'location',
  twitter_table: 'twitter table',
  youtube_table: 'youtube table',
  trending_posts_map:'trending posts map',
  youtube_posts: 'youtube posts',
  paid_promotion: 'paid promotion',
  subscribers: 'subscribers',
  views: 'views',
  video_type_post: 'video URL / ID',
};

export const ar = {
  video_type_post: 'فيديو رابط /الرمز',
  views: 'المشاهدات',
  subscribers: 'مُشتركين',
  paid_promotion: 'الترويج المدفوع',
  youtube_posts: 'منشورات اليوتيوب',
  youtube_table: 'جدول منشورات يوتيوب ',
  twitter_table: 'جدول منشورات تويتر',
  comments: 'التعليقات',
  plays: 'التشغيل',
  shares: 'المشاركات',
  saves: 'الحفظ',
  location: 'الموقع',
  likes: 'الاعجابات',
  downloads: 'التحميلات',
  advertisement: 'الإعلان',
  post_id: 'رمز المنشور',
  favorites: 'المُفضله',
  tiktok_table: 'جدول منشورات التيك توك',
  searchBy_post_id: 'ابحث بواسطه الرمز التعريفي',
  posted_on: 'نُشر في ',
  tiktok_posts: 'منشورات التيك توك',
  comments_status: 'حاله التعليقات',
  number_of_instagram_posts: 'عدد منشورات الانستقرام',
  total_posts:'كل المنشورات',
  number_of_tiktok_posts: 'عدد منشورات التيك توك',
  posts_breakdown:'تفاصيل المنشورات',
  number_of_linkedin_posts: 'عدد منشورات لينكد ان',
  trending_posts_map:'خريطة الفيدوهات الترند',
  enabled: 'متاح',
  edited: 'تم التعديل',
  posts_sentiment_analysis: 'تحليل الأراء للمنشور',
  view_replies: 'مشاهده الردود',
  hide_replies: 'اخفاء الردود',
  most_mentioned_users: 'المسخدمون الأكثر ذكرا',
  post_exists_incomplete: ' المنشور تم اضافته من قبل ، انقر هنا لعرض التفاصيل ',
  duplicate_post: 'هذا المنشور تم إضافته من قبل',
  post: 'المنشور',
  invalid_Post: 'رابط / رمز المنشور غير صحيح',
  max_Post: 'هذه الحقل مطلوب ويجب أن لا يزيد عن 150 حرف',
  min_Post: 'هذه الحقل مطلوب ويجب أن لا يقل عن حرفين',
  type_post: 'نوع المنشور رابط /رمز',
  tiktok_type_post: 'نوع المنشور رابط /رمز',
  add_new_post: 'إضافه منشور جديد',
  post_details: 'تفاصيل المنشور',
  disabled: 'غير متاح',
  co_author_producer: 'المؤلف المشارك',
  tagged_users: 'المستخدمون المشار اليهم',
  most_frequent_word: 'الكلمات الأكثر تكراراً',
  post_media_classification: 'تصنيف وسائط المنشور',
  comments_sentiment: 'تحليل نسب الآراء للتعليقات ',
  sponsored: 'مُمول',
  pin: 'مُثبت',
  influencer_details: 'تفاصيل المؤثر/الكيان',
  posts: 'المنشورات',
  instagram_table: 'جدول المنشورات',
  linkedin_table: 'جدول المنشورات',
  searchBy_caption: 'ابحث بواسطه محتوي المنشور',
  searchBy_post_code: 'ابحث بواسطه رمز المنشور',
  post_type: 'نوع المنشور',
  post_code: 'رمز المنشور',
  comments: 'التعليقات',
  media_count: 'عدد الوسائط ',
  media_type: 'نوع الوسائط ',
  posted_at: 'نُشر في',
  instagram_posts: 'منشورات الانستقرام',
  linkedin_posts: 'منشورات لينكدان',
  incomplete: 'غير مكتمله',
  total_reactions: 'جميع التفاعلات',
  post_total_reactions: 'جميع تفاعلات المنشور',
  post_hashtags: 'هاشتاقات المنشور',
  post_reposts: 'اعادات نشر المنشور',
  reposts: 'اعادات النشر',
  analyze: 'محلل',
  hashtags: 'الهاشتاقات',
  tagged_user: 'المستخدمون المشار اليهم',
  mentioned_user: 'المستخدمون المذكورون',
  selectGrab: 'اختار ماذا يتم جلبه للمنشورات المختارة قبل التحميل',
  post_date: 'تاريخ المنشور',
  post_likes: 'الإعجابات المنشور',
  post_comments: 'تعليقات المنشور',
  post_shares: 'مشاركه المنشور',
  post_saves: 'حفظ المنشور',
  post_sponsored: 'برعايه المنشور',
  post_pinned: 'ثبت المنشور ',
  post_plays: 'عدد مرات التشغيل للمنشور ',
  post_views: 'مشاهدات المنشور ',
  post_location: 'موقع المنشور ',
  post_media: 'وسائط المنشور',
  most_mentioned_users: 'المسخدمون الأكثر ذكرا',
  frequently_used_hashtags: 'الهاشتاقات المستخدمه الأكثر تكرار',
  frequently_used_words: 'الكلمات المستخدمة الاكثر تكرار',
  regrab_reply_conversation: 'إعاده المزامنه للرد علي المحادثه',
  reply_conversation: 'الرد علي المحادثه',
  replies: 'الردود',
  search_by_comment_reply: 'ابحث بواسطه محتوي التعليق /الرد ',
  comment: 'تعليق',
  reply: 'رد',
};
